// extracted by mini-css-extract-plugin
export default {"items":"AutoSlider_items__v3Qg5","img":"AutoSlider_img__iRK3h"};